export default function checkStatus(status) {
    let state = status.toUpperCase()
    switch(state) {
        case 'POSTED': return 'success';
        case 'DRAFT': return 'warning';
        case 'REVERSED': return 'grey';
        case 'UNPAID': return 'error';
        case 'PAID': return 'success';
        case 'OPEN': return 'blue';
        case 'OVERDUE': return 'error';
        case 'CLOSED': return 'error';
        case 'REJECTED': return 'error';
        case 'RECEIVED': return 'blue';
        case 'TRANSFERED': return 'blue';
        default: return 'primary'
    }
}